import React from 'react'
import t from '../../../translations'
import { checkServerUp } from '../App'

export default function Maintenance(props) {
    checkServerUp()
    setInterval(() => {
        checkServerUp()
    }, 1000 * 60)   // 1 minutes

    return <h2>{t[props.lang]['Website under maintenance...']}</h2>
}